import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

const getAnAggregatorOfferLettersAndSlas = async (customer_id) => {
  const { data } = await getDataWithDotNet(
    `${ajaxEndpoints.AN_AGGREGATOR_OFFER_LETTERS_AND_SLAS}/${customer_id}`
  );
  return data;
};

export default function useAnAggregatorOfferLettersAndSlas(customer_id) {
  return useQuery(
    [customer_id, "getAnAggregatorOfferLettersAndSlas"],
    getAnAggregatorOfferLettersAndSlas,
    {
      refetchOnWindowFocus: false,
    }
  );
}
